"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _commons = require("@focaltec-suite/commons");
var _api = require("@focaltec-suite/api");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function NotificationViewer(_ref) {
  var notification = _ref.notification,
    onUpdated = _ref.onUpdated,
    onClose = _ref.onClose;
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    source = _useState2[0],
    setSource = _useState2[1];
  (0, _react.useEffect)(function () {
    if (notification.read) return;
    (0, _api.updateNotification)(notification.id, {
      read: true
    }, {
      access: access
    }).then(onUpdated)["catch"](function (error) {
      return console.error(error);
    });
  }, [notification, access, onUpdated]);
  var getPromise = (0, _react.useCallback)(function () {
    var _a, _b;
    var url = (_b = (_a = notification === null || notification === void 0 ? void 0 : notification.metadata) === null || _a === void 0 ? void 0 : _a.email) === null || _b === void 0 ? void 0 : _b.html_url;
    if (url) {
      return (0, _api.secure)({
        http_method: 'GET',
        key: url,
        seconds: 60
      }, {
        access: access
      });
    }
    return (0, _api.emptyPromise)();
  }, [notification, access]);
  var setData = (0, _react.useCallback)(function (response) {
    setSource(response === null || response === void 0 ? void 0 : response.url);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    open: true,
    onClose: onClose,
    title: notification.subject,
    fullScreen: !!source,
    fullWidth: !source,
    maxWidth: "md"
  }, /*#__PURE__*/_react["default"].createElement(_commons.Retrievable, {
    getPromise: getPromise,
    setData: setData,
    builder: function builder() {
      if (source) {
        return /*#__PURE__*/_react["default"].createElement("iframe", {
          title: notification.subject,
          src: source,
          width: "100%",
          height: "100%",
          frameBorder: "0"
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, notification.text);
    }
  }));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(NotificationViewer);